import React from 'react';
import Card from '../../lib/card/Card';
import { Project } from '../../pages/Gallery';
import { Box, Chip } from '@mui/material';
import type { ChipProps } from '@mui/material/Chip';
import { ProPlanChip } from '../ProPlanChip';

interface MarketplaceCardProps {
	project: Project;
	disableTitleCapitalize?: boolean;
	disabled?: boolean;
	/** Each item is passed straight to MUI <Chip /> */
	tags?: ChipProps[];
	isPaid?: boolean;
	onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const MarketplaceCard: React.FC<MarketplaceCardProps> = ({
	project,
	disableTitleCapitalize = false,
	disabled = false,
	tags = [],
	isPaid = false,
	onClick,
}) => {
	const coverPictureUrl = project.media.find((m) => m.type === 'cover')?.url;
	const iconPictureUrl = project.media.find((m) => m.type === 'icon')?.url;

	return (
		<Card
			disabled={false}
			onClick={onClick}
			tooltip={disabled ? <div className='tooltip gallery-card-tooltip'>Request access</div> : undefined}
		>
			<div className='card-content'>
				{/* TOP-LEFT TAGS */}
				{(tags.length > 0 || isPaid) && (
					<Box className='card-tags'>
						{isPaid && <ProPlanChip disabled={disabled} />}
						{tags.map((chip, i) => (
							<Chip
								key={i}
								size='small'
								color='primary'
								variant='filled'
								className='card-tag'
								{...chip}
							/>
						))}
					</Box>
				)}

				{coverPictureUrl ? (
					<img src={coverPictureUrl} className='card-image card-image--cover' style={disabled ? { opacity: 0.5 } : undefined} />
				) : iconPictureUrl ? (
					<img src={iconPictureUrl} className={`card-image card-image--icon bg-color-${
							(project.assignedFallbackColor ?? 0) + 1
						}--light`} style={disabled ? { opacity: 0.5 } : undefined} />
				) : (
					<div
						className={`card-image bg-color-${
							(project.assignedFallbackColor ?? 0) + 1
						}`}
						style={disabled ? { opacity: 0.5 } : undefined}
					>
						<i className='fa-solid fa-server'></i>
					</div>
				)}

				<div className='card-info-section' style={disabled ? { opacity: 0.5 } : undefined}>
					<div className='card-info-section--left'>
						<h3
							className={`card-title truncated-title ${
								disableTitleCapitalize ? '' : 'all-uppercase'
							}`}
						>
							{project.name || 'untitled'}
						</h3>
						<p className='card-description'>{project.description || ''}</p>
					</div>
				</div>
			</div>
		</Card>
	);
};

export default MarketplaceCard;
